/**
 * Contains data for email messages to be sent with receiving logs
 */
export class EmailData {

    public constructor(init?: Partial<EmailData>) {
        if (init) {
          Object.assign(this, init);
        }
      }

      includePhotosInEmail: boolean = true;

      userEmail: string = '';
   
    /**
     * The delivery or shelf location address
     */
    address: string = '';
    
    /**
     * The type of log: "Service" or "Project"
     */
    logType: string = '';
    
    /**
     * The list of email recipients
     */
    recipients: Array<string>= [];
    

    
    /**
     * Email for Service logs
     */
    serviceEmails: Array<string>= [];
    
    /**
     * Email for Project logs
     */
    projectEmails: Array<string>= [];
    

}
